import { createFileRoute } from '@tanstack/react-router'
import { outboxSearchSchema } from '../../../features/messaging/search'
import { requireLink } from '../../../features/settings/guards'
import { MessageOutboxPage } from '../../../features/settings/message-outbox-page'

export const Route = createFileRoute('/_app/settings/message-outbox')({
  staticData: { crumb: 'settingsSection' },
  validateSearch: outboxSearchSchema,
  beforeLoad: ({ context }) => requireLink(context.session, 'messageOutbox'),
  component: MessageOutboxPage,
})
